import React from 'react';
import { FiWifiOff, FiAlertCircle, FiClock } from 'react-icons/fi';
import './StatusIcon.css';

const StatusIcon = ({ status, ultimaLeitura, className = '' }) => {
  // Helper formatação de tempo da última leitura
  const formatTimeAgo = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 1) return 'Agora';
    if (diffMins < 60) return `${diffMins}m`;
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `${diffHours}h`;
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays}d`;
  };

  const minutos = status?.minutosOffline || 0;

  // Helper para formatar tempo de offline
  const formatTempoOffline = (mins) => {
    if (mins < 60) return `${mins}m`;
    const totalHoras = Math.floor(mins / 60);
    const minsRestantes = mins % 60;
    if (totalHoras < 24) {
      return `${totalHoras}h${minsRestantes > 0 ? `${minsRestantes}m` : ''}`;
    }
    const dias = Math.floor(totalHoras / 24);
    const horasRestantes = totalHoras % 24;
    return `${dias}d${horasRestantes > 0 ? ` • ${horasRestantes}h` : ''}${minsRestantes > 0 ? ` • ${minsRestantes}m` : ''}`;
  };

  // Determinar ícone baseado no tipo de problema
  const getStatusInfo = () => {
    // Status Normal: Mostra a última atualização
    if (!status || !status.problema) {
      const timeAgo = formatTimeAgo(ultimaLeitura);
      return {
        Icon: FiClock,
        className: 'status-normal',
        title: `Última atualização: ${ultimaLeitura ? new Date(ultimaLeitura).toLocaleString('pt-BR') : 'Desconhecida'}`,
        tempo: timeAgo ? `há ${timeAgo}` : 'Desconhecido'
      };
    }

    // Status sem dados (módulo ou canal específico)
    if (status.status === 'sem_dados' || status.status === 'canal_sem_dados') {
      return {
        Icon: FiAlertCircle,
        className: 'status-sem-dados',
        title: status.mensagem || 'Nenhuma medição encontrada',
        tempo: minutos > 0 ? formatTempoOffline(minutos) : null
      };
    }

    // Problema de comunicação (offline)
    return {
      Icon: FiWifiOff,
      className: 'status-problema',
      title: status.mensagem || `Offline há ${formatTempoOffline(minutos)}`,
      tempo: formatTempoOffline(minutos)
    };
  };

  const statusInfo = getStatusInfo();
  const { Icon } = statusInfo;

  return (
    <div
      className={`status-icon ${statusInfo.className} ${className}`}
      title={statusInfo.title}
    >
      <Icon className="status-icon__svg" />
      {statusInfo.tempo && (
        <span className="status-tempo">{statusInfo.tempo}</span>
      )}
    </div>
  );
};

export default StatusIcon;
